var _excluded = ["svgRef"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#7F7F7F",
  stroke: "#404041",
  strokeMiterlimit: 10,
  d: "M26,358c0-6.6,0-13.2,0-19.8c0.1-0.9,0.3-1.7,0.4-2.6 c0.8-16.1,3.3-32,7.5-47.7c9.5-35.6,26.9-67.9,51.9-97c10-11.7,21-22.6,33.5-32.3c1.2-0.9,2.2-1.7,4-1.7 c88.6,0.1,177.1,0.1,265.7,0.1c1.1,0,2.4,0.4,3.2,1c3.4,2.6,6.8,5.3,10,8.1c23.4,20.8,41.9,44.5,56.1,71.1 c17,31.7,26.1,65.1,27.6,100.1c0.9,20.1-0.6,40.1-4.6,59.8c-1.3,6.4-2.2,13-4.7,19.1c-7.3,18.2-21,31.7-41,39.7 c-12.2,4.9-25.2,6.5-38.5,6.5c-93.7,0-187.5,0-281.2-0.1c-5.5,0-11-0.2-16.4-0.9C78.4,459.1,61,450.9,47.7,436 c-6-6.8-11-14.1-13.3-22.5c-4.1-15.4-6.6-31-7.7-46.8C26.5,363.8,26.3,360.9,26,358z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7F7F7F",
  stroke: "#404041",
  strokeMiterlimit: 10,
  d: "M342.7,49.6 c3.9,0.3,7.8,0.6,11.6,1c16.2,1.8,31,6.8,44.9,14.3c14.3,7.7,26.8,17.4,37.3,29c0.5,0.5,0.9,1.1,1.5,1.7 c-6.3,5.2-12.4,10.3-18.5,15.4c-14.8,12.3-29.5,24.5-44.3,36.8c-1.5,1.2-2.9,1.7-4.9,1.7c-76.4-0.1-152.9-0.1-229.3,0 c-1.7,0-2.8-0.5-4-1.4C116.5,131.1,96,114,75.5,96.9c-0.4-0.4-0.8-0.7-1.5-1.3c1.2-1.3,2.3-2.7,3.5-4c17.1-17.7,37.6-31,62.9-37.9 c8.8-2.4,17.8-3.6,26.9-3.9c0.5,0,1-0.1,1.5-0.2c1.8,0,3.7,0,5.6,0c3.4,0.3,6.8,0.5,10.2,0.9c12.9,1.5,24.6,5.7,35.9,11.1 c7.4,3.6,14.8,7.1,22.4,10.3c4.9,2.1,10.2,3.2,15.8,2.5c5.2-0.7,10.1-2.2,14.8-4.4c6.2-2.9,12.3-5.9,18.5-8.9 c10.9-5.3,22.3-9.2,34.7-10.6c3.4-0.4,6.8-0.6,10.2-0.9C339,49.6,340.8,49.6,342.7,49.6z"
});

var SvgBag2 = function SvgBag2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBag2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bag2.f3132eaa.svg";
export { ForwardRef as ReactComponent };